import { render, staticRenderFns } from "./imgDetails.vue?vue&type=template&id=45ce3692&scoped=true&"
import script from "./imgDetails.vue?vue&type=script&lang=ts&"
export * from "./imgDetails.vue?vue&type=script&lang=ts&"
import style0 from "./imgDetails.vue?vue&type=style&index=0&id=45ce3692&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ce3692",
  null
  
)

export default component.exports